import React      from 'react';
import LeadMap    from "../components/Leadmap/LeadMap";
import {
    mapService,
    NotificationService
}                 from "../services";
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import {Col, Row} from "reactstrap";
import NotificationAlert
                  from 'react-notification-alert/index';

class CompareMap extends React.Component {
    constructor(props) {
        super(props);
        var fd = moment().subtract('months', 1).toDate();
        this.state = {
            leadData: null,
            regionData: null,
        }
    }

    componentDidMount() {
        mapService.getAllRegions().then(response => {
            var outer = {
                type: "FeatureCollection",
                features: []
            }
            response.forEach(r => {
                outer.features.push({
                    "id": r.PolyID,
                    "type": "Feature",
                    "properties": JSON.parse(r.PolyProperties),
                    "geometry": r.PolyGeom
                })
            })
            this.setState({regionData:outer})
        }).catch(error => {
            this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "Error: "+error+". Functionality is disabled."));
        })
        this.updateLeads();
    }

    updateLeads = () => {
        mapService.getCompareLeadMarkers().then(response => {
            var outer = {
                type: "FeatureCollection",
                features: []
            }
            if (response) {
                response.forEach(r => {
                    outer.features.push({
                        "type": "Feature",
                        "geometry": {
                            type: 'Point',
                            coordinates:[
                                r.Lng,
                                r.Lat
                            ]
                        },
                        'properties': {
                            'title': 'Mapbox DC',
                            'icon': 'monument'
                        }
                    })
                });

            }
            this.setState({leadData: outer})
        });
    }

    render() {
        return (
            <>
                <NotificationAlert ref="notificationAlert" />
                <div className="content">
                    <Row>
                        <Col xs="12">
                            <div className={`lead-map--info--wrapper`}>
                                <div className={`lead-map--info--total`}>Leads: {this.state.leadData && this.state.leadData.features != undefined && this.state.leadData.features.length}</div>
                            </div>
                            <LeadMap leadData={this.state.leadData} regionData={this.state.regionData}/>
                        </Col>
                    </Row>
                </div>
            </>
        )
    }
}

export default CompareMap